/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Password/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import VisibilityAction from './VisibilityAction/index'



/** @type {import('Simple/types.js').View} */
export default function Password({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/Password",
  isInvalid,
  onChange,
  onSubmit
  
}) {
  let flow = fromFlow.useFlow()
let resetPasswordConfirmPasswordValueData = fromData.useDataValue({ viewPath,
context: 'reset_password_confirm',
path: 'password',
})
let resetPasswordConfirmPasswordIsValidData = fromData.useDataIsValid({ viewPath,
context: 'reset_password_confirm',
path: 'password',
validate: fromValidate.password,
required: true,
})
let resetPasswordConfirmPasswordChangeData = fromData.useDataChange({ viewPath,
context: 'reset_password_confirm',
path: 'password',
})
let resetPasswordConfirmPasswordSubmitData = fromData.useDataSubmit({ viewPath,
context: 'reset_password_confirm',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 autoFocus={true}
 data="reset_password_confirm.password"
 validate="/Data/validate.js password"
 required={true}
 invalid={!resetPasswordConfirmPasswordIsValidData}
 value={resetPasswordConfirmPasswordValueData}
 onChange={resetPasswordConfirmPasswordChangeData}
 onSubmit={resetPasswordConfirmPasswordSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="New Password"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type={flow.has(fromFlow.normalizePath(viewPath, 'VisibilityAction/Show')) ? "text" : "password"}
 placeholder="Create new password"
/>
<VisibilityAction
{...childProps}
  viewPath={`${viewPath}/VisibilityAction`}
/>
</React.Fragment>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}